// extracted by mini-css-extract-plugin
module.exports = {"main":"EditorialeTemplate_main__l_XB4","cookiebotContainer":"EditorialeTemplate_cookiebotContainer__Ze0Gb","rotation":"EditorialeTemplate_rotation__iGMuF"};